import * as React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import { AppRouting } from '../../AppConstants';
import { Loading } from '../Loading/Loading';

import styles from './Layout.module.scss';
import { Sidebar } from '../Sidebar/Sidebar';
import { PopoverDialog } from '../PopoverDialog/PopoverDialog';
import { observer } from 'mobx-react';
import { AppStore, AppStoreContext } from '../../Stores/AppStore';
import { useMemo } from 'react';
import { FilterSection } from '../Filters/FilterSection';
import {authService} from "../../index";

const Users = React.lazy(() => import('../Pages/Users/Users'));
const Organizations = React.lazy(() => import('../Pages/Organizations/Organizations'));

export const Layout = observer(() => {
    const appStore = useMemo(() => new AppStore(), []);
    const { isGlobalAdmin, isGlobalSupport, isUser } = authService;

    return (
        <div className={styles.root}>
            <AppStoreContext.Provider value={appStore}>
                <Router>
                    <Sidebar/>
                    <div className={styles.main}>
                        <FilterSection isGlobalRole={isGlobalAdmin || isGlobalSupport}/>
                        <div className={styles.body}>
                            <React.Suspense fallback={<Loading isSuspense/>}>
                                <Switch>
                                    {!isUser && <Route path={AppRouting.Users} component={Users}/>}
                                    {isGlobalAdmin && <Route path={AppRouting.Organizations} component={Organizations}/>}
                                    <Redirect exact from="/" to={AppRouting.Users}/>
                                </Switch>
                            </React.Suspense>
                        </div>
                        <PopoverDialog/>
                        <Loading loading={appStore.siteLoader.isPending}/>
                    </div>
                </Router>
            </AppStoreContext.Provider>
        </div>
    );
});

